import React from "react";
import { Box, Flex, Heading, Icon, List, ListItem, Text, Badge } from "@chakra-ui/react";
import { FiAlertTriangle } from "react-icons/fi";

export function IneligibleProductsList({ products = [] }) {
  if (!products.length) return null;

  return (
    <Box
      bg="white"
      borderRadius="xl"
      border="1px solid"
      borderColor="red.200"
      boxShadow="lg"
      p={6}
    >
      <Flex align="center" mb={4}>
        <Icon as={FiAlertTriangle} color="red.500" boxSize={6} mr={3} />
        <Heading size="md" color="gray.800" fontWeight="semibold">
          Products Failed for Scoring
        </Heading>
      </Flex>

      <Flex justify="space-between" px={4} mb={2}>
        <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" letterSpacing="wide">
          Product Name
        </Text>
        <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" letterSpacing="wide">
          Product Count
        </Text>
      </Flex>

      <List spacing={2}>
        {products.map((p, idx) => (
          <ListItem
            key={idx}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            px={4}
            py={2}
            borderRadius="md"
            bg="orange.50"
            border="1px solid"
            borderColor="orange.100"
          >
            <Text fontSize="sm" fontWeight="medium" color="gray.700">
              {p.productName}
            </Text>
            <Badge colorScheme="orange" variant="subtle" px={2} py={1} borderRadius="full">
              {p.productCount}
            </Badge>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}